import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms"

export class ResetPasswordRequestForm extends UntypedFormGroup {
  constructor() {
    super({
      'username': new UntypedFormControl("", [Validators.required])
    })
  }
}
